// Utilities.
// eslint-disable-next-line
export const unpackError = (response) => {
    const errors = [];

    if (response.data && response.data.modelState) {
        Object.values(response.data.modelState).forEach((message) => {
            if (message instanceof Array) {
                message.forEach((m) => {
                    errors.push(m);
                });
            } else {
                errors.push(message);
            }
        });
    }

    if (!errors.length) {
        if (response.data && response.data.exception) {
            errors.push(response.data.exception);
        }
    }

    if (!errors.length) {
        if (response.data && response.data.message) {
            errors.push(response.data.message);
        }
    }

    if (!errors.length) {
        errors.push('Unexpected error, please try again in a few minutes.');
    }

    return errors;
};
